import React from 'react';
import { Glob as G } from "../libs/Glob.mjs";
import {Button, ButtonGroup} from "reactstrap";
import UnlinkIcon from "../media/images/UnlinkIcon.mjs";
import UserFlags from "./adminControls/UserFlags.mjs";

const AdminGroupUser = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = { me: G.getUserLogin() };
		this.uid = G.generateUid('AdminGroupUser');
	}
	render() {
		const u = this.props.user;
		return(
			<tr>
				<td>
					<UserFlags user={u} />
				</td>
				<td>
					{u.user}
				</td>
				<td>
					{u.name}
				</td>
				<td>
					{u.mail ?? '—'}
				</td>
				<td>
					{ this.props.group.id === 'admin' ? '' : (
						<ButtonGroup className={"btn-icon"}>
							<Button
								color={"link"}
								onClick={ () => {
									this.props.change('unlink', { user: u.user, group: this.props.group.id });
								}}
							>
								<UnlinkIcon />
							</Button>
						</ButtonGroup>
					) }
				</td>
			</tr>
		)
	}
}

export default AdminGroupUser;
